"use client";

import React from "react";
import PointsLoader from "@/app/(components)/generics/loaders/PointsLoader/PointsLoader";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./Button.module.css";

export enum ButtonVariant {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  SUCCESS = "success",
  DANGER = "danger",
  GHOST = "ghost",
}

export enum ButtonSize {
  SM = "sm",
  MD = "md",
  LG = "lg",
}

type Props = {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  disabled?: boolean;
  fullWidth?: boolean;
  type?: "button" | "submit" | "reset";
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  icon?: React.ComponentType<any>;
  children?: React.ReactNode;
};

export default function Button(props: Props) {
  const {
    variant = ButtonVariant.PRIMARY,
    size = ButtonSize.MD,
    loading = false,
    disabled = false,
    fullWidth = false,
    type = "button",
    onClick,
    className,
    icon: Icon,
    children,
  } = props;

  const loaderDark = variant === ButtonVariant.SECONDARY || variant === ButtonVariant.GHOST;

  return (
    <button
      type={type}
      className={UStyles.classNames(
        styles.button,
        styles[variant],
        styles[size],
        fullWidth ? styles.fullWidth : "",
        Icon && children ? styles.withIcon : "",
        className || "",
      )}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? (
        <PointsLoader dark={loaderDark} />
      ) : (
        <>
          {Icon && <Icon />}
          {children}
        </>
      )}
    </button>
  );
}
